define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var BaseDropdownViewController = require('web-agent-components/BaseDropdownViewController');
    var Bubble=require("ui/bubble/Bubble");

    var NumericDropdownViewController = BaseDropdownViewController.extend({
        ControllerName: "NumericDropdownViewController",

        LPViewMap: {
            selectedView: ".lpview_selected_value"
        },

        initialize: function (constructorData) {
            this.itemClickedCallback = constructorData.valueChangedCallback;
            this.context = constructorData.context;
            this.showValidationErrorBubble = false;

        },

        events:function(){
            this.bindViewEvent({view:this.focusedView,DOMEvent:"mouseenter",callback:this.onMouseEnter});
            this.bindViewEvent({view:this.focusedView,DOMEvent:"mouseleave",callback:this.onMouseLeave});
        },

        render: function () {
            this.setButtonText();
        }
    });

    NumericDropdownViewController.prototype.onMouseEnter = function(){
        if(this.showValidationErrorBubble && _.isUndefined(this.bubbleComponent)) {
            this.bubbleComponent = new Bubble({
                text: this.translate('history_search_numeric_range_validation_error'),
                targetControl: this.view,
                containerSelector:'div.lpview_filter_container.filter_full_table_listview',
                position: Bubble.POSITION.TOP,
                align: Bubble.ALIGN.MIDDLE,
                isDelayed: true,
                delay: 1,
                zIndex: 99999,
            });
            this.bubbleComponent.render();
        }
    };

    NumericDropdownViewController.prototype.onMouseLeave = function() {
        if (!_.isUndefined(this.bubbleComponent)) {
            this.bubbleComponent.close(true);
            delete this.bubbleComponent;
        }
    };

    NumericDropdownViewController.prototype.setShowValidationErrorBubble = function(showValidationErrorBubble) {
        this.showValidationErrorBubble = showValidationErrorBubble;
    };


    NumericDropdownViewController.prototype.getConfiguration = function () {
        var configuration = {
            templateFile: "LP_button_dropdown.html",
            rowTemplateFile: "LP_form_dropdown_row.html",
            focusedViewClass: this.LPViewMap.focusElement
        };
        return configuration;
    };

    NumericDropdownViewController.prototype.onItemClicked = function (data) {
        BaseDropdownViewController.prototype.onItemClicked.call(this, data);
        if (!this.enabled) {
            return;
        }
        if (!data.rowData.disabled) {
            this.setButtonText();
            this.collapseItems();
            this.callItemClickedCallback(data);
        }
    };

    NumericDropdownViewController.prototype.onFocusedViewClicked = function (e) {
        BaseDropdownViewController.prototype.onFocusedViewClicked.call(this, e);
        if (this.itemsDisplayed) {
            this.collapseItems();
        } else {
            this.expandItems();
        }
    };

    NumericDropdownViewController.prototype.setSelectedIndex = function (index) {
        BaseDropdownViewController.prototype.setSelectedIndex.call(this, index);
        this.setButtonText();
        this.collapseItems();
    };

    NumericDropdownViewController.prototype.setButtonText = function () {
        if (typeof this.selectedIndex === "undefined") {
            this.getFirstElement(this.LPViewMap.selectedView).innerHTML = this.titleText;
        }
        else if (this.selectedIndex >= 0) {
            var buttonText = this.items[this.selectedIndex][this.textProperty];
            this.getFirstElement(this.LPViewMap.selectedView).innerHTML = lpUtils.escapeHTML(buttonText);
        }
    };

    NumericDropdownViewController.prototype.callItemClickedCallback = function (data) {
        if (this.itemClickedCallback) {
            this.itemClickedCallback.call(this.context, parseInt(data.rowData.text));
        }
    };

    return NumericDropdownViewController;

});
